import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'stringLocalzation',
    standalone: true
})
export class StringLocalzationPipe implements PipeTransform {

    transform(value: any, ...args: unknown[]): unknown {
        if (value) {
            return value.toLocaleString();
        }
        return '';
    }

}
